import { render, staticRenderFns } from "./storeInformation2.vue?vue&type=template&id=81bfb3a0&scoped=true&"
import script from "./storeInformation2.vue?vue&type=script&lang=js&"
export * from "./storeInformation2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bfb3a0",
  null
  
)

export default component.exports